import { COUNTRY_CODES } from "../../../constants/countries";

export const INVOICE_LIST_CONFIG = {
    [COUNTRY_CODES.ECUADOR]: {
        showNotasCredito: true,
        showTicketGenerico: true,
    },
    [COUNTRY_CODES.PARAGUAY]: {
        showNotasCredito: true,
        showTicketGenerico: true,
        showTicket: true,
        showFactura: true,
        showContabilizar: true,
    },
    [COUNTRY_CODES.HONDURAS]: {
        showNotasCredito: true,
        showTicketGenerico: true,
        showFactura: true,
        showContabilizar: true,
    },
    [COUNTRY_CODES.ELSALVADOR]: {
        showNotasCredito: false,
        showTicketGenerico: true,
        showFactura: true,
        showContabilizar: true,
    },
    [COUNTRY_CODES.PERU]: {
        showNotasCredito: true,
        showTicketGenerico: true,
        showFactura: true,
        showContabilizar: true,
    },
};

export const getInvoiceListConfig = (pais) => { return INVOICE_LIST_CONFIG[pais] || INVOICE_LIST_CONFIG[COUNTRY_CODES.ECUADOR]; };